module.exports = __webpack_public_path__ + "static/media/smartmessage.433666d9.png";